module.exports = __webpack_public_path__ + "img/upload.129bd752.svg";